var _filter, _defs, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "waves"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: " 0.900  0.000  0.000  0.000  0.100  0.000  0.900  0.000  0.100  0.100  0.000  0.000  0.900  0.807  0.100  0.700  0.500  0.400  0.400  0.100"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "       0.75 0 0 0 0       0 0.75 0 0 0       0 0 0.75 0 0       0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 375,
    y1: 0,
    x2: 375,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4F3EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0693,
    style: {
      stopColor: "#DAF5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    style: {
      stopColor: "#EDFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6786,
    style: {
      stopColor: "#F9FDC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    style: {
      stopColor: "#FDFEC2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    filter: "url(#waves)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FADA8"
    },
    d: "M750,134.981L739.5,132c0,0-22-18-26-19s-32.5-11.5-35-12.5s-31-19-34.5-19.5 s-46.5-26-48.5-25.5s-24.5,22.5-28,24S534,109,531.5,111s-27,33-29,35S474,163,472,163.5S443.5,174,441.5,176s-34,34-34,34 L381,221l-36-7.5l-29.5-7.5L293,187.5l-15.5-7.5c0,0-19.5-25-21-26s-15.5-7-17.5-8.5S217.5,125,217.5,125s-24.5,19.5-26,19.5 s-25.5,12-28,13S141,177,139,177.5s-25.5,8-27,8s-31.5,3-33,4s-18,10-19.5,10.5s-20,3.5-21.5,4s-16,1-18.5,2.5 c-1.565,0.939-11.952,6.387-19.5,10.329V500h750V134.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A9B96"
    },
    d: "M163.5,157.5c-2.5,1-22.5,19.5-24.5,20s-25.5,8-27,8s-31.5,3-33,4s-18,10-19.5,10.5 s-20,3.5-21.5,4s-16,1-18.5,2.5c-1.565,0.939-11.952,6.387-19.5,10.329V316.5h363.5l-14-21c0,0-26.5-23-29.5-24 s-16.5-12-16.5-12l-27,16.5l22.5-22.5c0,0-8-13.5-11-14s-10-12-12.5-13S263,214,263,214l-36.5,15.5L263,207c0,0-5-3.5-8-4.5 s-11.5-9.5-11.5-9.5l-11-18.5l-24.5,15l24.5-24.5c0,0-6.5-9.5-8.5-12s-6.5-28-6.5-28s-24.5,19.5-26,19.5 S166,156.5,163.5,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87C1B9"
    },
    d: "M255.5,157.5l16,22.25l21.5,7.75l-15.5-7.5c0,0-19.5-25-21-26s-15.5-7-17.5-8.5 S217.5,125,217.5,125l22,27L255.5,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A9B96"
    },
    d: "M399,250c0,0-11,15-12,16.5s-71.5,50-71.5,50h198l16.5-38l-73,19l74.5-26L528,253 c0,0,2-29,3-32s13.75-20,13.75-20L494,207l50.5-11.5c0,0-2-9-1-11.5s9.5-16,12-19s8-14,8.5-16.5s2.5-17.5,2.5-17.5L528,143 l40-19c0,0,0.5-11.5,3-14s14-20,15.5-23s9-31.5,9-31.5c-2,0.5-24.5,22.5-28,24S534,109,531.5,111s-27,33-29,35 S474,163,472,163.5S443.5,174,441.5,176s-34,34-34,34l-20,30.5L399,250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87C1B9"
    },
    d: "M662.5,96.5l10,11.5l41.5,9.5l21.5,23H750v-5.519L739.5,132c0,0-22-18-26-19 s-32.5-11.5-35-12.5s-31-19-34.5-19.5c-3.428-0.49-44.731-24.951-48.318-25.494L595.5,55.5l35,26L662.5,96.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#508C85"
    },
    d: "M750,251.146c-14.989,5.178-36.084,12.576-38,13.854c-3,2-23,17.5-26.5,19s-26.5,7.5-30,7.5 s-30,3.5-34,3.5s-40-12.5-44-12.5s-17-2-21.5-1.5s-25,4-28,4.5s-28.5,10-31.5,12.548c-3,2.548-23.5-2.548-26-3.048 s-27.5-8-32.5-8s-10.5,4-13.5,4.5s-14.5,0-18-1.5s-10-7-14.5-6.5s-18.5,3-20.5,2.5s-21,0.5-23.5,0.5s-13,6.5-16.5,6.5 s-13-3.5-18.5-4s-21-4.5-26-4.5s-25.5,4.5-32,5.5s-19,2-23,3.5s-11,5-15.5,4.5s-18-5.5-22-6.5s-41.5-6.5-47.5-7 s-11.5-5.5-13.5-7s-16-5.5-20-6s-22.5-10-27-10s-29,1-32,0s-7.5-5-10-6s-17-7-23-5.5c-3.654,0.914-13.981,0.714-21.5,0.419 V500h750V251.146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "189.356,297.294 198.361,261.375 207.365,297.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "238.465,292.207 247.469,256.288 256.474,292.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "226.335,297.294 235.34,261.375 244.344,297.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "143.049,294.018 152.053,258.099 161.057,294.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "152.053,290.108 161.057,254.19 170.061,290.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "182.813,298.25 189.356,272.149 195.9,298.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "214.579,300.349 221.122,274.248 227.665,300.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "253.315,298.25 259.858,272.149 266.401,298.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "331.78,294.018 340.784,258.099 349.788,294.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "355.002,293.223 364.006,257.304 373.011,293.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "320.335,297.294 329.34,261.375 338.344,297.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "274.991,288.136 283.996,252.218 293,288.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "285.991,292.207 294.996,256.288 304,292.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "343.245,296.278 349.788,270.177 356.331,296.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "308.957,296.278 315.5,270.177 322.043,296.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "381.982,294.179 388.525,268.078 395.068,294.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "373.011,287.298 379.554,261.197 386.097,287.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "468.113,298.597 477.117,262.678 486.122,298.597  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "491.335,297.802 500.34,261.883 509.344,297.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "548.002,283.735 557.006,247.817 566.011,283.735  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "524.858,289.173 533.862,253.255 542.867,289.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "560.666,290.108 569.67,254.19 578.674,290.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "697.666,278.827 706.67,242.908 715.674,278.827  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "731.916,260.867 740.92,224.948 749.924,260.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "602.666,295.706 611.67,259.787 620.674,295.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "456.669,297.802 465.673,261.883 474.677,297.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "411.325,292.715 420.329,256.796 429.333,292.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "422.325,296.786 431.329,260.867 440.333,296.786  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "486.122,300.857 492.665,274.756 499.208,300.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "438.747,290.797 445.29,264.696 451.833,290.797  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "445.29,300.857 451.833,274.756 458.376,300.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "454.587,293.688 461.13,267.587 467.673,293.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "400.624,293.688 407.167,267.587 413.71,293.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "686.447,293.621 695.451,257.702 704.455,293.621  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "675.002,292.825 684.006,256.907 693.011,292.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "629.658,297.116 638.662,261.197 647.667,297.116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "640.658,301.187 649.662,265.268 658.667,301.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "657.081,295.198 663.624,269.097 670.167,295.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "663.624,305.258 670.167,279.157 676.71,305.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "710.5,272.837 717.043,246.736 723.586,272.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "725.372,260.867 731.916,234.766 738.459,260.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "672.92,288.712 679.463,262.611 686.006,288.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "618.957,298.089 625.5,271.988 632.043,298.089  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "518.315,298.758 524.858,272.657 531.401,298.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "578.674,297.315 585.217,271.214 591.76,297.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "585.217,303.159 591.76,277.058 598.303,303.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "591.76,291.877 598.303,265.776 604.847,291.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "509.344,291.877 515.887,265.776 522.43,291.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "538.344,285.199 544.887,259.099 551.43,285.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "167.232,289.892 173.775,263.791 180.318,289.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "72.032,267.959 81.036,232.041 90.04,267.959  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "100.006,281.75 109.01,245.831 118.015,281.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "91.002,270.177 100.006,234.258 109.011,270.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "7.715,263.791 16.72,227.872 25.724,263.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "28.789,257.126 37.794,221.208 46.798,257.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "16.72,257.126 25.724,221.208 34.728,257.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "62.024,265.268 68.567,239.167 75.11,265.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "84.459,269.128 91.002,243.027 97.545,269.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "117.982,282.178 124.525,256.077 131.068,282.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "42.124,263.051 48.667,236.949 55.21,263.051  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#467971"
    },
    d: "M0,287.78c0,0,52.072,8.107,59.369,8.663s31.964,0.11,34.631,0 c2.667-0.11,23.301,10.468,23.301,10.468s54.699,7.832,57.366,7.627c2.667-0.205,30.931-4.456,30.931-4.456 s31.257,3.933,33.736,1.08c2.479-2.852,50.667-1.151,53.667,1.343c3,2.494,46.116,1.315,51.964,2.213 c5.848,0.898,64.369-9.23,67.703-7.808c3.333,1.422,38.971,7.029,42.1,7.531c3.129,0.501,61.764-1.044,64.719,0.096 c2.955,1.14,63.111-13.273,69.181-15.078c6.07-1.804,37.87,2.954,44.328,1.978s49.553,1.86,53.883-0.409 c4.33-2.269,63.122-16.765,63.122-16.765V500H0V287.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M535.768,138.923c-2.195-2.507-4.4-5.441-7.406-6.221c-2.153-0.801-4.671,0.967-6.387,0.582 c-2.143-0.375-3.474-2.476-5.628-3.277c-3.87-1.186-7.719-1.519-11.994-1.842c-4.692,0.114-8.114-0.229-11.568-1.852 c-4.317-2.029-6.512-4.536-11.214-4.848c-4.275-0.323-8.052,2.33-11.88,2.85c-4.681,0.541-8.145-1.509-12.348,1.154 c-3.776,2.652-5.774,8.249-9.987,10.486c-3.797,1.799-8.957,0.218-11.412,4.546L535.768,138.923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M47.058,168.595c3.406-3.891,6.829-8.445,11.495-9.656c3.342-1.243,7.249,1.501,9.913,0.904 c3.326-0.581,5.393-3.843,8.735-5.086c6.006-1.841,11.98-2.358,18.616-2.859c7.282,0.177,12.594-0.356,17.954-2.875 c6.7-3.149,10.107-7.04,17.405-7.525c6.636-0.501,12.497,3.616,18.439,4.423c7.266,0.839,12.642-2.342,19.165,1.791 c5.861,4.117,8.962,12.803,15.501,16.274c5.893,2.793,13.901,0.339,17.712,7.055L47.058,168.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M324.248,79.244c-9.164-6.898-15.212-5.049-24.525-5.949 c-11.296-1.617-18.477-7.798-29.024-12.731c-11.196-5.615-25.259-3.3-35.822-7.566c-11.896-4.299-22.309-14.563-35.705-12.231 c-16.078,2.932-18.445,17.544-29.958,24.591c-9.481,5.765-25.426,3.365-31.024,13.894L324.248,79.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M741.273,85.615c-2.514-11.99-11.59-12.236-20.682-11.914 c-13.63,0.199-15.04-10.626-26.217-17.174c-12.879-6.594-22.032-4.003-34.099,1.347 c-11.484,4.798-23.137,15.837-34.498,16.097c-10.794,0.275-22.063-2.868-31.293,2.559c-2.315,1.64-4.677,4.983-7.544,6.04 c-2.867,1.058-4.538-0.123-6.823,0.383c-4.569,1.012-8.602,3.173-12.619,4.768L741.273,85.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M72.808,96.157c1.287-6.14,5.935-6.266,10.591-6.101c6.98,0.102,7.702-5.441,13.425-8.794 c6.595-3.377,11.282-2.05,17.461,0.69c5.881,2.457,11.848,8.11,17.666,8.243c5.527,0.141,11.298-1.469,16.025,1.31 c1.186,0.84,2.395,2.552,3.863,3.093c1.468,0.542,2.324-0.063,3.494,0.196c2.34,0.518,4.405,1.625,6.462,2.441L72.808,96.157z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113339830415843053570000002115167707116975795_",
    gradientUnits: "userSpaceOnUse",
    x1: 375,
    y1: 500,
    x2: 375,
    y2: 323.0548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4F3EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    style: {
      stopColor: "#D8F4E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6204,
    style: {
      stopColor: "#E4F7DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    style: {
      stopColor: "#F9FDC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    style: {
      stopColor: "#FDFEC2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 323.055,
    style: {
      fill: "url(#SVGID_00000113339830415843053570000002115167707116975795_)"
    },
    width: 750,
    height: 176.945
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116196473351987993140000003283765038223349947_",
    y: 323.055,
    style: {
      opacity: 0.5
    },
    width: 750,
    height: 176.945
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165949999580725432680000004720374948206721725_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116196473351987993140000003283765038223349947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165949999580725432680000004720374948206721725_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FADA8"
    },
    d: "M750,511.039l-10.5,2.981c0,0-22,18-26,19s-32.5,11.5-35,12.5s-31,19-34.5,19.5 s-46.5,26-48.5,25.5s-24.5-22.5-28-24s-33.5-29.5-36-31.5s-27-33-29-35s-28.5-17-30.5-17.5s-28.5-10.5-30.5-12.5 s-34-34-34-34l-26.5-11l-36,7.5l-29.5,7.5l-22.5,18.5l-15.5,7.5c0,0-19.5,25-21,26s-15.5,7-17.5,8.5s-21.5,20.5-21.5,20.5 s-24.5-19.5-26-19.5s-25.5-12-28-13s-22.5-19.5-24.5-20s-25.5-8-27-8s-31.5-3-33-4s-18-10-19.5-10.5s-20-3.5-21.5-4 s-16-1-18.5-2.5c-1.565-0.939-11.952-6.387-19.5-10.329V146.02h750V511.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A9B96"
    },
    d: "M163.5,488.52c-2.5-1-22.5-19.5-24.5-20s-25.5-8-27-8s-31.5-3-33-4s-18-10-19.5-10.5 s-20-3.5-21.5-4s-16-1-18.5-2.5c-1.565-0.939-11.952-6.387-19.5-10.329V329.52h363.5l-14,21c0,0-26.5,23-29.5,24 s-16.5,12-16.5,12l-27-16.5l22.5,22.5c0,0-8,13.5-11,14s-10,12-12.5,13s-12.5,12.5-12.5,12.5l-36.5-15.5l36.5,22.5 c0,0-5,3.5-8,4.5s-11.5,9.5-11.5,9.5l-11,18.5l-24.5-15l24.5,24.5c0,0-6.5,9.5-8.5,12s-6.5,28-6.5,28s-24.5-19.5-26-19.5 S166,489.52,163.5,488.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87C1B9"
    },
    d: "M255.5,488.52l16-22.25l21.5-7.75l-15.5,7.5c0,0-19.5,25-21,26s-15.5,7-17.5,8.5 s-21.5,20.5-21.5,20.5l22-27L255.5,488.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A9B96"
    },
    d: "M399,396.02c0,0-11-15-12-16.5s-71.5-50-71.5-50h198l16.5,38l-73-19l74.5,26l-3.5,18.5 c0,0,2,29,3,32s13.75,20,13.75,20l-50.75-6l50.5,11.5c0,0-2,9-1,11.5s9.5,16,12,19s8,14,8.5,16.5s2.5,17.5,2.5,17.5 l-38.5-12l40,19c0,0,0.5,11.5,3,14s14,20,15.5,23s9,31.5,9,31.5c-2-0.5-24.5-22.5-28-24s-33.5-29.5-36-31.5s-27-33-29-35 s-28.5-17-30.5-17.5s-28.5-10.5-30.5-12.5s-34-34-34-34l-20-30.5L399,396.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87C1B9"
    },
    d: "M662.5,549.52l10-11.5l41.5-9.5l21.5-23H750v5.519l-10.5,2.981c0,0-22,18-26,19 s-32.5,11.5-35,12.5s-31,19-34.5,19.5c-3.428,0.49-44.731,24.951-48.318,25.494l-0.182,0.006l35-26L662.5,549.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#508C85"
    },
    d: "M750,394.874c-14.989-5.178-36.084-12.576-38-13.854c-3-2-23-17.5-26.5-19 s-26.5-7.5-30-7.5s-30-3.5-34-3.5s-40,12.5-44,12.5s-17,2-21.5,1.5s-25-4-28-4.5s-28.5-10-31.5-12.548 c-3-2.548-23.5,2.548-26,3.048s-27.5,8-32.5,8s-10.5-4-13.5-4.5s-14.5,0-18,1.5s-10,7-14.5,6.5s-18.5-3-20.5-2.5 s-21-0.5-23.5-0.5s-13-6.5-16.5-6.5s-13,3.5-18.5,4s-21,4.5-26,4.5s-25.5-4.5-32-5.5s-19-2-23-3.5s-11-5-15.5-4.5 s-18,5.5-22,6.5s-41.5,6.5-47.5,7s-11.5,5.5-13.5,7s-16,5.5-20,6s-22.5,10-27,10s-29-1-32,0s-7.5,5-10,6s-17,7-23,5.5 c-3.654-0.914-13.981-0.714-21.5-0.419V146.02h750V394.874z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "189.356,348.726 198.361,384.645 207.365,348.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "238.465,353.813 247.469,389.732 256.474,353.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "226.335,348.726 235.34,384.645 244.344,348.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "143.049,352.002 152.053,387.921 161.057,352.002  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "152.053,355.912 161.057,391.831 170.061,355.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "182.813,347.77 189.356,373.871 195.9,347.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "214.579,345.671 221.122,371.772 227.665,345.671  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "253.315,347.77 259.858,373.871 266.401,347.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "331.78,352.002 340.784,387.921 349.788,352.002  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "355.002,352.797 364.006,388.716 373.011,352.797  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "320.335,348.726 329.34,384.645 338.344,348.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "274.991,357.884 283.996,393.802 293,357.884  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "285.991,353.813 294.996,389.732 304,353.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "343.245,349.742 349.788,375.843 356.331,349.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "308.957,349.742 315.5,375.843 322.043,349.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "381.982,351.841 388.525,377.942 395.068,351.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "373.011,358.722 379.554,384.823 386.097,358.722  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "468.113,347.423 477.117,383.342 486.122,347.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "491.335,348.219 500.34,384.137 509.344,348.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "548.002,362.285 557.006,398.203 566.011,362.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "524.858,356.847 533.862,392.765 542.867,356.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "560.666,355.912 569.67,391.831 578.674,355.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "697.666,367.194 706.67,403.112 715.674,367.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "731.916,385.153 740.92,421.072 749.924,385.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "602.666,350.314 611.67,386.233 620.674,350.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "456.669,348.219 465.673,384.137 474.677,348.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "411.325,353.305 420.329,389.224 429.333,353.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "422.325,349.234 431.329,385.153 440.333,349.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "486.122,345.164 492.665,371.264 499.208,345.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "438.747,355.223 445.29,381.324 451.833,355.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "445.29,345.164 451.833,371.264 458.376,345.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "454.587,352.332 461.13,378.433 467.673,352.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "400.624,352.332 407.167,378.433 413.71,352.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "686.447,352.4 695.451,388.318 704.455,352.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "675.002,353.195 684.006,389.113 693.011,353.195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "629.658,348.904 638.662,384.823 647.667,348.904  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "640.658,344.833 649.662,380.752 658.667,344.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "657.081,350.822 663.624,376.923 670.167,350.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "663.624,340.763 670.167,366.863 676.71,340.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "710.5,373.183 717.043,399.284 723.586,373.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "725.372,385.153 731.916,411.254 738.459,385.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "672.92,357.309 679.463,383.409 686.006,357.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "618.957,347.931 625.5,374.032 632.043,347.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "518.315,347.262 524.858,373.363 531.401,347.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "578.674,348.705 585.217,374.806 591.76,348.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "585.217,342.861 591.76,368.962 598.303,342.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "591.76,354.143 598.303,380.244 604.847,354.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "509.344,354.143 515.887,380.244 522.43,354.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "538.344,360.821 544.887,386.922 551.43,360.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "167.232,356.128 173.775,382.229 180.318,356.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "72.032,378.061 81.036,413.98 90.04,378.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "100.006,364.27 109.01,400.189 118.015,364.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "91.002,375.843 100.006,411.762 109.011,375.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "7.715,382.229 16.72,418.148 25.724,382.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "28.789,388.894 37.794,424.812 46.798,388.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "16.72,388.894 25.724,424.812 34.728,388.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "62.024,380.752 68.567,406.853 75.11,380.752  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "84.459,376.893 91.002,402.994 97.545,376.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "117.982,363.842 124.525,389.943 131.068,363.842  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#508C85"
    },
    points: "42.124,382.97 48.667,409.071 55.21,382.97  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#467971"
    },
    d: "M0,358.24c0,0,52.072-8.107,59.369-8.663s31.964-0.11,34.631,0 c2.667,0.11,23.301-10.468,23.301-10.468s54.699-7.832,57.366-7.627c2.667,0.205,30.931,4.456,30.931,4.456 s31.257-3.933,33.736-1.08c2.479,2.852,50.667,1.151,53.667-1.343c3-2.494,46.116-1.315,51.964-2.213 c5.848-0.898,64.369,9.23,67.703,7.808c3.333-1.422,38.971-7.029,42.1-7.531c3.129-0.501,61.764,1.044,64.719-0.096 c2.955-1.14,63.111,13.273,69.181,15.078c6.07,1.804,37.87-2.954,44.328-1.978s49.553-1.86,53.883,0.409 c4.33,2.269,63.122,16.765,63.122,16.765V146.02H0V358.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M535.768,507.097c-2.195,2.507-4.4,5.441-7.406,6.221c-2.153,0.801-4.671-0.967-6.387-0.582 c-2.143,0.375-3.474,2.476-5.628,3.277c-3.87,1.186-7.719,1.519-11.994,1.842c-4.692-0.114-8.114,0.229-11.568,1.852 c-4.317,2.029-6.512,4.536-11.214,4.848c-4.275,0.323-8.052-2.33-11.88-2.85c-4.681-0.541-8.145,1.509-12.348-1.154 c-3.776-2.652-5.774-8.249-9.987-10.486c-3.797-1.799-8.957-0.218-11.412-4.546L535.768,507.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M17.65,463.624c3.407,3.891,6.829,8.444,11.495,9.656c3.342,1.243,7.25-1.501,9.914-0.904 c3.326,0.581,5.392,3.843,8.735,5.086c6.006,1.841,11.98,2.358,18.616,2.859c7.282-0.177,12.594,0.356,17.954,2.875 c6.7,3.149,10.107,7.04,17.405,7.525c6.636,0.501,12.497-3.616,18.439-4.423c7.266-0.839,12.642,2.342,19.165-1.791 c5.861-4.117,8.962-12.803,15.501-16.274c5.893-2.793,13.901-0.339,17.712-7.055L17.65,463.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M324.248,566.776c-9.164,6.898-15.212,5.049-24.525,5.949 c-11.296,1.617-18.477,7.798-29.024,12.731c-11.196,5.615-25.259,3.3-35.822,7.566 c-11.896,4.299-22.309,14.563-35.705,12.231c-16.078-2.932-18.445-17.544-29.958-24.591 c-9.481-5.765-25.426-3.365-31.024-13.894L324.248,566.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M741.125,554.93c-2.953,14.085-13.616,14.374-24.297,13.996 c-16.012-0.233-17.669,12.483-30.798,20.175c-15.129,7.746-25.882,4.702-40.058-1.583 c-13.491-5.637-27.18-18.604-40.527-18.91c-12.68-0.323-25.918,3.37-36.761-3.006c-2.72-1.927-5.494-5.853-8.862-7.096 s-5.331,0.144-8.015-0.45c-5.367-1.188-10.105-3.728-14.824-5.601L741.125,554.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF9E4"
    },
    d: "M72.808,549.863c1.287,6.14,5.935,6.266,10.591,6.101c6.98-0.102,7.702,5.442,13.425,8.794 c6.595,3.377,11.282,2.05,17.461-0.69c5.881-2.457,11.848-8.11,17.666-8.243c5.527-0.141,11.298,1.469,16.025-1.31 c1.186-0.84,2.395-2.552,3.863-3.093c1.468-0.542,2.324,0.063,3.494-0.196c2.34-0.518,4.405-1.625,6.462-2.441 L72.808,549.863z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152259383181937680010000005516623338098647231_",
    y: 323.055,
    style: {
      opacity: 0.7
    },
    width: 750,
    height: 176.945
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070829367977779542340000001722600520897045147_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152259383181937680010000005516623338098647231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070829367977779542340000001722600520897045147_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M548.002,347c0,0,10.766,13.168,21.798,16.668c11.032,3.5,29.84,11.948,33.194,16.121 s28.831,0.596,36.213,0c7.382-0.596,27.166,9.784,31.693,10.805c4.527,1.021,26.904,10.407,34.494,9.339 c7.59-1.068,45.818,3.167,45.818,3.167V347H548.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M728.344,394.766c2.507-1.032,3.982-1.18,3.982-1.18c-7.963,9.438-8.995,19.53-8.995,19.53 c3.097-0.672,5.161,0,5.161,0c-3.097,1.687-5.456,4.901-5.456,4.901c2.478-0.829,3.82-1.202,3.82-1.202 c-6.208,7.156-9.866,25.686-9.866,25.686c1.917-0.781,4.793-1.21,4.793-1.21c-5.143,9.678-6.335,16.941-6.335,16.941 c0.965-0.396,2.409-0.074,2.409-0.074c-1.95,2.262-3.263,4.535-3.263,4.535l2.101-0.995 c-3.834,2.654-5.385,13.33-5.385,13.33c1.1-0.811,2.583-0.63,2.583-0.63c-3.687,3.982-6.194,14.009-6.194,14.009 s-2.507-10.028-6.194-14.009c0,0,1.483-0.181,2.583,0.63c0,0-1.551-10.676-5.385-13.33l2.101,0.995 c0,0-1.312-2.273-3.263-4.535c0,0,1.443-0.322,2.409,0.074c0,0-1.192-7.263-6.335-16.941c0,0,2.876,0.428,4.793,1.21 c0,0-3.658-18.53-9.866-25.686c0,0,1.342,0.373,3.82,1.202c0,0-2.359-3.214-5.456-4.901c0,0,2.065-0.672,5.161,0 c0,0-1.032-10.092-8.996-19.53c0,0,1.475,0.147,3.982,1.18c0,0-2.359-5.234-6.194-9.991h26.839h26.839 C730.703,389.532,728.344,394.766,728.344,394.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M708.868,395.881c1.994-0.821,3.167-0.938,3.167-0.938 c-6.334,7.507-7.155,15.535-7.155,15.535c2.463-0.535,4.106,0,4.106,0c-2.463,1.342-4.34,3.899-4.34,3.899 c1.971-0.66,3.039-0.956,3.039-0.956c-4.938,5.692-7.848,20.431-7.848,20.431c1.525-0.622,3.812-0.962,3.812-0.962 c-4.091,7.698-5.039,13.475-5.039,13.475c0.768-0.315,1.916-0.059,1.916-0.059c-1.551,1.799-2.595,3.607-2.595,3.607 l1.672-0.792c-3.05,2.111-4.283,10.603-4.283,10.603c0.875-0.645,2.055-0.501,2.055-0.501 c-2.932,3.167-4.927,11.144-4.927,11.144s-1.994-7.977-4.927-11.144c0,0,1.18-0.144,2.055,0.501 c0,0-1.234-8.492-4.284-10.603l1.672,0.792c0,0-1.044-1.808-2.595-3.607c0,0,1.148-0.256,1.916,0.059 c0,0-0.948-5.777-5.039-13.475c0,0,2.287,0.34,3.812,0.962c0,0-2.91-14.739-7.848-20.431c0,0,1.067,0.297,3.039,0.956 c0,0-1.877-2.557-4.34-3.899c0,0,1.642-0.535,4.105,0c0,0-0.821-8.028-7.155-15.535c0,0,1.173,0.117,3.167,0.938 c0,0-1.877-4.164-4.927-7.947h21.349h21.349C710.745,391.717,708.868,395.881,708.868,395.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M751.316,399.85c1.994-0.821,3.167-0.938,3.167-0.938c-6.334,7.507-7.155,15.535-7.155,15.535 c2.463-0.535,4.106,0,4.106,0c-2.463,1.342-4.34,3.899-4.34,3.899c1.971-0.66,3.038-0.956,3.038-0.956 c-4.938,5.692-7.848,20.431-7.848,20.431c1.525-0.622,3.812-0.962,3.812-0.962c-4.091,7.698-5.039,13.475-5.039,13.475 c0.768-0.315,1.916-0.059,1.916-0.059c-1.551,1.799-2.595,3.607-2.595,3.607l1.672-0.792 c-3.05,2.111-4.283,10.603-4.283,10.603c0.875-0.645,2.055-0.501,2.055-0.501c-2.932,3.167-4.927,11.144-4.927,11.144 s-1.994-7.977-4.927-11.144c0,0,1.18-0.144,2.055,0.501c0,0-1.234-8.492-4.283-10.603l1.672,0.792 c0,0-1.044-1.808-2.595-3.607c0,0,1.148-0.256,1.916,0.059c0,0-0.948-5.777-5.039-13.475c0,0,2.287,0.34,3.812,0.962 c0,0-2.91-14.739-7.848-20.431c0,0,1.067,0.297,3.039,0.956c0,0-1.877-2.557-4.34-3.899c0,0,1.642-0.535,4.106,0 c0,0-0.821-8.028-7.155-15.535c0,0,1.173,0.117,3.167,0.938c0,0-1.877-4.164-4.927-7.947h21.349h21.349 C753.193,395.687,751.316,399.85,751.316,399.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M660.035,389.149c2.829-1.165,4.493-1.331,4.493-1.331 c-8.986,10.65-10.151,22.039-10.151,22.039c3.495-0.759,5.824,0,5.824,0c-3.495,1.904-6.157,5.531-6.157,5.531 c2.796-0.935,4.311-1.357,4.311-1.357c-7.005,8.075-11.133,28.984-11.133,28.984c2.163-0.882,5.408-1.365,5.408-1.365 c-5.803,10.92-7.148,19.116-7.148,19.116c1.089-0.447,2.718-0.084,2.718-0.084c-2.201,2.552-3.682,5.117-3.682,5.117 l2.371-1.123c-4.327,2.995-6.077,15.042-6.077,15.042c1.241-0.915,2.915-0.71,2.915-0.71 c-4.16,4.493-6.989,15.809-6.989,15.809s-2.829-11.316-6.989-15.809c0,0,1.674-0.204,2.915,0.71 c0,0-1.75-12.047-6.077-15.042l2.371,1.123c0,0-1.481-2.565-3.682-5.117c0,0,1.629-0.363,2.718,0.084 c0,0-1.345-8.196-7.149-19.116c0,0,3.245,0.483,5.408,1.365c0,0-4.128-20.91-11.133-28.984c0,0,1.514,0.421,4.311,1.357 c0,0-2.662-3.627-6.157-5.531c0,0,2.33-0.759,5.824,0c0,0-1.165-11.389-10.151-22.039c0,0,1.664,0.166,4.493,1.331 c0,0-2.662-5.907-6.989-11.274h30.286h30.286C662.698,383.242,660.035,389.149,660.035,389.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M693.04,391.866c3.275-1.349,5.201-1.541,5.201-1.541 c-10.403,12.329-11.751,25.514-11.751,25.514c4.046-0.879,6.743,0,6.743,0c-4.046,2.204-7.128,6.403-7.128,6.403 c3.237-1.083,4.99-1.57,4.99-1.57c-8.109,9.348-12.889,33.554-12.889,33.554c2.504-1.021,6.261-1.58,6.261-1.58 c-6.719,12.642-8.276,22.13-8.276,22.13c1.261-0.518,3.146-0.097,3.146-0.097c-2.548,2.954-4.262,5.924-4.262,5.924 l2.745-1.3c-5.009,3.468-7.035,17.414-7.035,17.414c1.437-1.059,3.374-0.823,3.374-0.823 c-4.816,5.201-8.091,18.301-8.091,18.301s-3.275-13.1-8.091-18.301c0,0,1.938-0.236,3.375,0.823 c0,0-2.026-13.946-7.035-17.414l2.745,1.3c0,0-1.714-2.969-4.262-5.924c0,0,1.885-0.421,3.146,0.097 c0,0-1.557-9.488-8.276-22.13c0,0,3.757,0.559,6.261,1.58c0,0-4.779-24.207-12.889-33.554c0,0,1.753,0.487,4.99,1.57 c0,0-3.082-4.199-7.128-6.403c0,0,2.697-0.879,6.743,0c0,0-1.349-13.184-11.751-25.514c0,0,1.926,0.193,5.201,1.541 c0,0-3.082-6.838-8.091-13.051h35.061h35.061C696.122,385.028,693.04,391.866,693.04,391.866z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008870754207225143150000008637143122424437896_",
    y: 323.055,
    style: {
      opacity: 0.8
    },
    width: 750,
    height: 176.945
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120520774569465196000000005583768392810993310_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008870754207225143150000008637143122424437896_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120520774569465196000000005583768392810993310_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M-19.286,401.315h318.324c0,0-19.714,12.929-32.855,17.381 c-13.142,4.452-42.277,8.162-46.631,9.646c-4.354,1.484-34.778,17.067-42.198,20.777c-7.42,3.71-60.814,0-65.283,0 c-4.469,0-31.102,7.42-41.16,8.904c-10.057,1.484-43.908-1.484-48.131,0c-4.222,1.484-42.066,19.292-42.066,19.292V401.315z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M57.574,462.773c4.68-1.927,7.433-2.202,7.433-2.202 c-14.865,17.618-16.792,36.458-16.792,36.458c5.781-1.256,9.635,0,9.635,0c-5.781,3.149-10.185,9.149-10.185,9.149 c4.626-1.548,7.131-2.244,7.131-2.244c-11.588,13.358-18.417,47.948-18.417,47.948c3.579-1.458,8.947-2.258,8.947-2.258 c-9.6,18.065-11.826,31.624-11.826,31.624c1.802-0.74,4.496-0.138,4.496-0.138c-3.641,4.222-6.091,8.465-6.091,8.465 l3.923-1.858c-7.157,4.955-10.052,24.884-10.052,24.884c2.053-1.513,4.822-1.175,4.822-1.175 c-6.882,7.433-11.562,26.152-11.562,26.152s-4.68-18.719-11.562-26.152c0,0,2.769-0.338,4.822,1.175 c0,0-2.895-19.929-10.052-24.884l3.923,1.858c0,0-2.45-4.243-6.091-8.465c0,0,2.694-0.601,4.496,0.138 c0,0-2.225-13.558-11.826-31.624c0,0,5.368,0.799,8.947,2.258c0,0-6.829-34.59-18.417-47.948c0,0,2.505,0.696,7.131,2.244 c0,0-4.405-6-10.185-9.149c0,0,3.854-1.256,9.635,0c0,0-1.927-18.84-16.792-36.458c0,0,2.753,0.275,7.433,2.202 c0,0-4.404-9.771-11.562-18.65h50.101h50.101C61.978,453.002,57.574,462.773,57.574,462.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M86.493,448.635c3.548-1.461,5.635-1.67,5.635-1.67 c-11.269,13.356-12.73,27.639-12.73,27.639c4.382-0.952,7.304,0,7.304,0c-4.382,2.387-7.721,6.936-7.721,6.936 c3.507-1.173,5.406-1.701,5.406-1.701c-8.785,10.126-13.962,36.349-13.962,36.349c2.713-1.106,6.782-1.711,6.782-1.711 c-7.278,13.695-8.965,23.974-8.965,23.974c1.366-0.561,3.409-0.105,3.409-0.105c-2.76,3.201-4.617,6.417-4.617,6.417 l2.974-1.409c-5.426,3.756-7.621,18.864-7.621,18.864c1.556-1.147,3.655-0.891,3.655-0.891 c-5.217,5.635-8.765,19.825-8.765,19.825s-3.548-14.191-8.765-19.825c0,0,2.099-0.256,3.656,0.891 c0,0-2.195-15.108-7.621-18.864l2.974,1.409c0,0-1.857-3.217-4.617-6.417c0,0,2.042-0.456,3.408,0.105 c0,0-1.687-10.278-8.965-23.974c0,0,4.069,0.606,6.782,1.711c0,0-5.177-26.222-13.962-36.349c0,0,1.899,0.528,5.406,1.701 c0,0-3.339-4.549-7.722-6.936c0,0,2.922-0.952,7.304,0c0,0-1.461-14.282-12.73-27.639c0,0,2.087,0.209,5.635,1.67 c0,0-3.339-7.408-8.765-14.138h37.981h37.981C89.832,441.228,86.493,448.635,86.493,448.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M162.372,447.433c4.021-1.656,6.387-1.892,6.387-1.892 c-12.774,15.139-14.43,31.328-14.43,31.328c4.968-1.079,8.279,0,8.279,0c-4.967,2.706-8.752,7.862-8.752,7.862 c3.975-1.33,6.128-1.928,6.128-1.928c-9.958,11.478-15.826,41.202-15.826,41.202c3.075-1.253,7.688-1.94,7.688-1.94 c-8.25,15.523-10.162,27.174-10.162,27.174c1.549-0.636,3.864-0.119,3.864-0.119c-3.129,3.628-5.234,7.274-5.234,7.274 l3.371-1.597c-6.15,4.258-8.638,21.383-8.638,21.383c1.764-1.3,4.144-1.01,4.144-1.01 c-5.914,6.387-9.935,22.472-9.935,22.472s-4.021-16.085-9.935-22.472c0,0,2.379-0.29,4.144,1.01 c0,0-2.488-17.125-8.638-21.383l3.371,1.597c0,0-2.105-3.646-5.234-7.274c0,0,2.315-0.517,3.863,0.119 c0,0-1.912-11.651-10.162-27.174c0,0,4.613,0.687,7.688,1.94c0,0-5.868-29.723-15.826-41.202c0,0,2.152,0.598,6.128,1.928 c0,0-3.785-5.156-8.752-7.862c0,0,3.312-1.079,8.279,0c0,0-1.656-16.189-14.429-31.328c0,0,2.366,0.236,6.387,1.892 c0,0-3.785-8.397-9.935-16.026h43.052h43.052C166.156,439.037,162.372,447.433,162.372,447.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M211.45,499.973c-0.887-3.547-4.022-3.961-6.962-4.298c-0.03-3.388-0.297-8.606-1.627-9.516 c-1.997-1.367-5.593-1.764-5.793-4.162c-0.173-2.075-10.517-5.2-14.397-10.406c-0.137-6.865,0.62-26.868,0.814-30.743 c0.2-3.995,3.196-6.871,3.196-6.871h-10.587c0,0,1.798,1.677,2.691,4.474c0.893,2.797,1.304,15.581,1.504,18.577 c0.029,0.432,0.058,1.5,0.085,3.008c-2.326,1.852-7.928,6.265-8.874,6.58c-1.199,0.4-7.99,1.598-8.789,3.995 c-0.18,0.54-0.354,1.688-0.517,3.137l-7.473,3.983v1.568l7.259-3.399c-0.204,2.276-0.38,4.857-0.511,6.991 c-1.243,0.37-2.487,0.769-3.552,0.902c-1.997,0.2-3.795-0.799-5.793-0.799c-1.997,0-4.994,0.799-5.393,2.996 c-0.599,2.597,2.397,2.996,0.799,5.193c-0.599,0.999-1.798,0-2.397,1.798c-0.2,0.999,0,2.197,0.599,2.996 c1.598,2.197,4.195,0.999,6.192,1.798c2.597,0.999,4.794,3.795,7.59,0.4v0.2c2.996,0.799,7.391-0.2,10.587-0.599 c4.594-0.599,10.986-4.195,4.594-8.389c4.336-7.728-5.379-7.808-10.516-7.121c0.471-3.826,1.128-9.295,1.128-10.074 c0-1.215,5.194-2.78,6.991-3.18c1.395-0.31,6.094-3.504,8.132-4.921c0.121,10.714,0.157,29.558-0.142,30.349 c-0.399,1.058-4.195,2.937-4.195,6.35c0,1.604,0,4.839,0,7.82c-5.009-1.816-12.869-1.07-11.585,5.346 c-4.994,0.799-5.793,0.599-6.991,5.194c-0.599,1.997-1.598,2.197-0.599,4.594c0.4,1.598,1.798,3.795,2.796,4.794 c2.397,3.196,6.192,2.996,8.39,5.593c1.398,1.598,0.599,2.796,3.396,3.396c1.769,0.393,3.727-0.379,4.741-1.926 c1.974,0.98,4.248-0.205,6.245,0.128c1.998,0.4,2.197,2.197,4.395,0.599c1.398-0.999,1.398-2.996,0.799-4.594 c3.995,0.2,6.392,0.999,10.587-0.599c2.597-1.198,3.196-1.598,2.597-4.195c-0.2-0.799-0.999-1.598-1.199-2.597 c-0.2-0.799,0.599-1.398,0.4-2.397c-0.799-2.197-3.396-2.797-4.594-4.594c-1.598-2.397,0-1.798-0.399-4.594 c-0.785-4.119-6.574-7.077-9.241-3.212c-0.466-2.448-1.083-4.881-1.745-5.297c-0.988-0.621-3.917-1.851-5.553-2.521 c0.047-0.903,0.127-1.57,0.254-1.843c0.694-1.487,3.901-2.109,3.901-4.21c0-1.843,0.154-13.743,0.057-20.829 c0.816,0.779,2.068,1.786,3.938,2.886c4.195,2.467,9.189,4.106,9.189,6.083c0,1.151,0.068,4.79,0.124,7.631 c-0.189,0.184-0.432,0.398-0.923,0.538c-2.797,0.599-2.797,0.2-5.393-0.4c-5.393-1.398-3.396,2.797-3.196,6.192 c0.2,1.598-1.398,1.398,0.2,2.996c0.799,0.999,1.798,0.799,2.797,0.799c0.776,0,1.736-0.188,2.523-0.382 c0.896,1.352,1.974,2.681,3.469,3.179c1.199,0.4,2.397-0.2,3.396,0c0.799,0.4,1.598,1.598,2.796,1.997 c2.996,1.199,3.795-0.799,6.192-1.997C209.852,503.368,212.249,503.768,211.45,499.973z M178.59,509.927 c-0.064-1.879-0.118-4.036-0.112-5.883c1.397,0.374,3.723,1.086,4.408,1.832c0.352,0.383,0.654,1.571,0.898,2.948 c-1.716-0.387-3.704,0.122-4.693,1.535C178.94,510.21,178.769,510.066,178.59,509.927z M202.627,495.433 c-0.986-0.161-1.879-0.398-2.563-0.854c-0.518-0.415-0.875-1.151-1.238-1.821c0.014-1.971,0.013-4.23-0.044-5.465 c-0.116-2.502,3.08-0.332,3.679,1.379C202.827,489.718,202.746,493.019,202.627,495.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M244.159,465.474c-1.844-0.503-1.633,5.965-3.343,5.511 c-2.062,2.016-7.507-4.823-10.072-4.823c-1.204,0-4.815-0.516-4.987-2.408c0-2.236,3.611-1.72,4.987-2.064 c3.059-0.931,3.137-4.327,5.639-5.105c-0.087-2.328-0.332-5.006-0.995-5.385c-0.957-0.547-11.422-4.027-15.675-5.432 c0.008,2.525,0.046,4.59,0.139,5.26c0.286,2.064,3.841,3.096,3.841,5.396c0,1.966-0.377,12.45-0.593,17.18l7.645,6.627 l-1.032,1.345l-6.78-4.712c-0.121,2.627-0.305,7.54-0.44,11.273c2.824-0.091,5.859-1.478,8.423-1.336 c1.892,0,4.299,0.344,5.847,1.548c0.516,0.516,3.439,3.612,3.612,4.471c0.688,2.236-2.408,2.924-2.064,4.987 c0.516,2.752,3.439,1.376,1.376,4.643c-2.408,3.956-7.739,2.064-11.35,3.612c-3.268,1.376-5.331,4.471-9.115,4.127 l-0.344-0.172c-4.299,1.204-5.159-2.924-8.599-4.299c-3.955-1.376-7.395-2.064-8.943-6.363 c-0.344-1.548-1.72-3.439-2.064-4.987c-0.344-2.408,1.376-2.408,3.611-2.924c1.376-0.344,3.611-0.344,4.643-1.032 c1.892-1.204,0.86-2.58,2.58-4.128c3.82-3.342,6.756,0.236,9.898,1.47c0.336-8.518,1.108-28.237,1.108-29.865 c0-1.147-1.669-2.59-3.112-3.971c-0.027,2.486-0.206,5.165-0.843,5.326c-1.204,0.304-9.926,2.448-9.926,3.996 c0,0.902,0,4.064,0,6.545c1.725-0.664,3.432-1.061,5.971-0.182c4.5,1.667,7.223,5.756,1.439,6.633 c-2.084,1.815-5.328,0.238-7.63,0.074c-2.752-0.172-7.739,2.752-9.975,0c-1.032-1.376-0.344-3.956,0.86-4.643 c1.204-0.688,3.612,0,4.987-0.344c0.658-0.143,1.259-0.33,1.824-0.533c0.128-2.854,0.356-7.271,0.583-8.41 c0.344-1.72,10.147-4.127,10.319-5.955c0.109-1.157,0.257-3.563,0.352-5.173c-0.026-0.136-0.031-0.268-0.008-0.395 c0.026-0.145,0.048-0.363,0.067-0.631c0.02-0.354,0.032-0.569,0.032-0.572c0.164-3.841-0.099-14.254-0.099-16.511 c0-2.58-4.471-5.685-4.471-5.685h14.274c0,0-5.847,3.793-5.905,4.997c-0.034,0.704-0.126,6.225-0.139,11.104 c4.706,1.416,17.165,5.314,17.96,7.125c0.507,1.154,0.49,3.637,0.356,5.769c0.395,0.039,0.829,0.117,1.314,0.25 c2.064,0.688,3.096,2.236,4.815,3.44c1.72,1.032,3.956,1.548,4.987,3.783C251.038,468.226,246.395,465.99,244.159,465.474z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFDF98"
    },
    points: "0,323.055 668.347,323.055 0,333.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFDF98"
    },
    points: "0,355.667 449.453,355.667 0,374.832  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFDF98"
    },
    points: "750,450.333 141.333,450.333 704.667,500 750,500  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFDF98"
    },
    points: "750,401.949 278.243,401.949 750,411.527  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119108817980652787150000007558006282547993729_",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065784395182652120670000011224877021728734089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119108817980652787150000007558006282547993729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065784395182652120670000011224877021728734089_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M-19.286,401.949h318.324c0,0-19.714-12.929-32.855-17.381 c-13.142-4.452-42.277-8.162-46.631-9.646c-4.354-1.484-34.778-17.067-42.198-20.777c-7.42-3.71-60.814,0-65.283,0 c-4.469,0-31.102-7.42-41.16-8.904c-10.057-1.484-43.908,1.484-48.131,0c-4.222-1.484-42.066-19.292-42.066-19.292V401.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M57.574,340.491c4.68,1.927,7.433,2.202,7.433,2.202 c-14.865-17.618-16.792-36.458-16.792-36.458c5.781,1.256,9.635,0,9.635,0c-5.781-3.149-10.185-9.149-10.185-9.149 c4.626,1.548,7.131,2.244,7.131,2.244c-11.588-13.358-18.417-47.948-18.417-47.948c3.579,1.458,8.947,2.258,8.947,2.258 c-9.6-18.065-11.826-31.624-11.826-31.624c1.802,0.74,4.496,0.138,4.496,0.138c-3.641-4.222-6.091-8.465-6.091-8.465 l3.923,1.858c-7.157-4.955-10.052-24.884-10.052-24.884c2.053,1.513,4.822,1.175,4.822,1.175 c-6.882-7.433-11.562-26.152-11.562-26.152s-4.68,18.719-11.562,26.152c0,0,2.769,0.338,4.822-1.175 c0,0-2.895,19.929-10.052,24.884l3.923-1.858c0,0-2.45,4.243-6.091,8.465c0,0,2.694,0.601,4.496-0.138 c0,0-2.225,13.558-11.826,31.624c0,0,5.368-0.799,8.947-2.258c0,0-6.829,34.59-18.417,47.948c0,0,2.505-0.696,7.131-2.244 c0,0-4.405,6-10.185,9.149c0,0,3.854,1.256,9.635,0c0,0-1.927,18.84-16.792,36.458c0,0,2.753-0.275,7.433-2.202 c0,0-4.404,9.771-11.562,18.65h50.101h50.101C61.978,350.263,57.574,340.491,57.574,340.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M86.493,354.629c3.548,1.461,5.635,1.669,5.635,1.669 c-11.269-13.356-12.73-27.639-12.73-27.639c4.382,0.952,7.304,0,7.304,0c-4.382-2.387-7.721-6.936-7.721-6.936 c3.507,1.173,5.406,1.701,5.406,1.701c-8.785-10.126-13.962-36.349-13.962-36.349c2.713,1.106,6.782,1.711,6.782,1.711 c-7.278-13.695-8.965-23.974-8.965-23.974c1.366,0.561,3.409,0.105,3.409,0.105c-2.76-3.201-4.617-6.417-4.617-6.417 l2.974,1.409c-5.426-3.756-7.621-18.864-7.621-18.864c1.556,1.147,3.655,0.891,3.655,0.891 c-5.217-5.635-8.765-19.825-8.765-19.825s-3.548,14.191-8.765,19.825c0,0,2.099,0.256,3.656-0.891 c0,0-2.195,15.108-7.621,18.864l2.974-1.409c0,0-1.857,3.217-4.617,6.417c0,0,2.042,0.456,3.408-0.105 c0,0-1.687,10.278-8.965,23.974c0,0,4.069-0.606,6.782-1.711c0,0-5.177,26.223-13.962,36.349c0,0,1.899-0.528,5.406-1.701 c0,0-3.339,4.549-7.722,6.936c0,0,2.922,0.952,7.304,0c0,0-1.461,14.282-12.73,27.639c0,0,2.087-0.209,5.635-1.669 c0,0-3.339,7.408-8.765,14.138h37.981h37.981C89.832,362.037,86.493,354.629,86.493,354.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M162.372,355.831c4.021,1.656,6.387,1.892,6.387,1.892 c-12.774-15.139-14.43-31.328-14.43-31.328c4.968,1.079,8.279,0,8.279,0c-4.967-2.706-8.752-7.862-8.752-7.862 c3.975,1.33,6.128,1.928,6.128,1.928c-9.958-11.478-15.826-41.201-15.826-41.201c3.075,1.253,7.688,1.94,7.688,1.94 c-8.25-15.523-10.162-27.174-10.162-27.174c1.549,0.636,3.864,0.119,3.864,0.119c-3.129-3.628-5.234-7.274-5.234-7.274 l3.371,1.597c-6.15-4.258-8.638-21.383-8.638-21.383c1.764,1.3,4.144,1.01,4.144,1.01c-5.914-6.387-9.935-22.472-9.935-22.472 s-4.021,16.085-9.935,22.472c0,0,2.379,0.29,4.144-1.01c0,0-2.488,17.125-8.638,21.383l3.371-1.597 c0,0-2.105,3.646-5.234,7.274c0,0,2.315,0.517,3.863-0.119c0,0-1.912,11.651-10.162,27.174c0,0,4.613-0.687,7.688-1.94 c0,0-5.868,29.723-15.826,41.201c0,0,2.152-0.598,6.128-1.928c0,0-3.785,5.156-8.752,7.862c0,0,3.312,1.079,8.279,0 c0,0-1.656,16.189-14.429,31.328c0,0,2.366-0.236,6.387-1.892c0,0-3.785,8.397-9.935,16.026h43.052h43.052 C166.156,364.228,162.372,355.831,162.372,355.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M207.854,298.897c-2.397-1.198-3.196-3.196-6.192-1.997c-1.199,0.4-1.997,1.598-2.796,1.997 c-0.999,0.2-2.197-0.4-3.396,0c-1.495,0.498-2.573,1.827-3.469,3.179c-0.787-0.194-1.747-0.382-2.523-0.382 c-0.999,0-1.997-0.2-2.797,0.799c-1.598,1.598,0,1.398-0.2,2.996c-0.2,3.396-2.197,7.59,3.196,6.192 c2.597-0.599,2.597-0.999,5.393-0.4c0.491,0.14,0.734,0.354,0.923,0.538c-0.057,2.841-0.124,6.48-0.124,7.631 c0,1.977-4.994,3.616-9.189,6.083c-1.87,1.1-3.122,2.106-3.938,2.886c0.097-7.086-0.057-18.986-0.057-20.829 c0-2.102-3.207-2.724-3.901-4.21c-0.127-0.272-0.207-0.939-0.254-1.843c1.636-0.669,4.564-1.899,5.553-2.521 c0.662-0.416,1.279-2.849,1.745-5.297c2.668,3.864,8.457,0.906,9.241-3.212c0.399-2.797-1.199-2.197,0.399-4.594 c1.199-1.798,3.795-2.397,4.594-4.594c0.2-0.999-0.599-1.598-0.4-2.397c0.2-0.999,0.999-1.798,1.199-2.597 c0.599-2.597,0-2.996-2.597-4.195c-4.195-1.598-6.592-0.799-10.587-0.599c0.599-1.598,0.599-3.596-0.799-4.594 c-2.197-1.598-2.397,0.2-4.395,0.599c-1.997,0.333-4.271-0.852-6.245,0.128c-1.014-1.547-2.972-2.319-4.741-1.926 c-2.796,0.599-1.997,1.798-3.396,3.396c-2.197,2.597-5.993,2.397-8.39,5.593c-0.999,0.999-2.397,3.196-2.796,4.794 c-0.999,2.397,0,2.597,0.599,4.594c1.199,4.594,1.997,4.395,6.991,5.193c-1.283,6.416,6.577,7.162,11.585,5.346 c0,2.98,0,6.216,0,7.82c0,3.413,3.795,5.292,4.195,6.35c0.299,0.791,0.262,19.635,0.142,30.349 c-2.038-1.417-6.737-4.611-8.132-4.921c-1.798-0.4-6.991-1.965-6.991-3.18c0-0.779-0.657-6.248-1.128-10.074 c5.137,0.687,14.852,0.608,10.516-7.121c6.392-4.195,0-7.79-4.594-8.389c-3.196-0.4-7.59-1.398-10.587-0.599v0.2 c-2.796-3.396-4.994-0.599-7.59,0.4c-1.997,0.799-4.594-0.4-6.192,1.798c-0.599,0.799-0.799,1.998-0.599,2.996 c0.599,1.798,1.798,0.799,2.397,1.798c1.598,2.197-1.398,2.597-0.799,5.193c0.399,2.197,3.396,2.996,5.393,2.996 c1.998,0,3.795-0.999,5.793-0.799c1.066,0.133,2.309,0.532,3.552,0.902c0.131,2.134,0.306,4.715,0.511,6.991l-7.259-3.399 v1.568l7.473,3.983c0.162,1.449,0.337,2.597,0.517,3.137c0.799,2.397,7.59,3.595,8.789,3.995 c0.945,0.315,6.547,4.728,8.874,6.58c-0.027,1.508-0.056,2.575-0.085,3.008c-0.2,2.996-0.61,15.78-1.504,18.577 c-0.893,2.797-2.691,4.474-2.691,4.474h10.587c0,0-2.996-2.876-3.196-6.871c-0.194-3.875-0.951-23.879-0.814-30.743 c3.881-5.206,14.224-8.331,14.397-10.406c0.2-2.398,3.795-2.796,5.793-4.162c1.33-0.91,1.597-6.128,1.627-9.516 c2.94-0.338,6.075-0.751,6.962-4.298C212.249,299.497,209.852,299.896,207.854,298.897z M179.09,292.905 c0.989,1.413,2.977,1.922,4.693,1.535c-0.244,1.377-0.546,2.565-0.898,2.948c-0.685,0.746-3.011,1.458-4.408,1.832 c-0.006-1.846,0.048-4.003,0.112-5.883C178.769,293.198,178.94,293.055,179.09,292.905z M202.461,314.592 c-0.599,1.712-3.795,3.881-3.679,1.379c0.057-1.236,0.058-3.495,0.044-5.465c0.363-0.669,0.72-1.406,1.238-1.821 c0.684-0.456,1.577-0.692,2.563-0.854C202.746,310.245,202.827,313.546,202.461,314.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2F2F"
    },
    d: "M244.159,337.79c-1.844,0.503-1.633-5.965-3.343-5.511c-2.062-2.016-7.507,4.823-10.072,4.823 c-1.204,0-4.815,0.516-4.987,2.408c0,2.236,3.611,1.72,4.987,2.064c3.059,0.931,3.137,4.327,5.639,5.105 c-0.087,2.328-0.332,5.006-0.995,5.385c-0.957,0.547-11.422,4.027-15.675,5.432c0.008-2.525,0.046-4.59,0.139-5.26 c0.286-2.064,3.841-3.096,3.841-5.396c0-1.966-0.377-12.45-0.593-17.18l7.645-6.627l-1.032-1.345l-6.78,4.712 c-0.121-2.627-0.305-7.54-0.44-11.273c2.824,0.091,5.859,1.478,8.423,1.336c1.892,0,4.299-0.344,5.847-1.548 c0.516-0.516,3.439-3.612,3.612-4.471c0.688-2.236-2.408-2.924-2.064-4.987c0.516-2.752,3.439-1.376,1.376-4.643 c-2.408-3.956-7.739-2.064-11.35-3.611c-3.268-1.376-5.331-4.472-9.115-4.128l-0.344,0.172 c-4.299-1.204-5.159,2.924-8.599,4.299c-3.955,1.376-7.395,2.064-8.943,6.363c-0.344,1.548-1.72,3.439-2.064,4.987 c-0.344,2.408,1.376,2.408,3.611,2.924c1.376,0.344,3.611,0.344,4.643,1.032c1.892,1.204,0.86,2.58,2.58,4.128 c3.82,3.342,6.756-0.236,9.898-1.47c0.336,8.518,1.108,28.237,1.108,29.865c0,1.147-1.669,2.59-3.112,3.971 c-0.027-2.486-0.206-5.165-0.843-5.326c-1.204-0.304-9.926-2.448-9.926-3.996c0-0.902,0-4.064,0-6.545 c1.725,0.664,3.432,1.061,5.971,0.182c4.5-1.667,7.223-5.756,1.439-6.633c-2.084-1.815-5.328-0.238-7.63-0.074 c-2.752,0.172-7.739-2.752-9.975,0c-1.032,1.376-0.344,3.956,0.86,4.643c1.204,0.688,3.612,0,4.987,0.344 c0.658,0.143,1.259,0.33,1.824,0.533c0.128,2.854,0.356,7.271,0.583,8.41c0.344,1.72,10.147,4.127,10.319,5.955 c0.109,1.157,0.257,3.563,0.352,5.173c-0.026,0.136-0.031,0.268-0.008,0.395c0.026,0.145,0.048,0.363,0.067,0.631 c0.02,0.354,0.032,0.569,0.032,0.572c0.164,3.841-0.099,14.254-0.099,16.51c0,2.58-4.471,5.685-4.471,5.685h14.274 c0,0-5.847-3.793-5.905-4.997c-0.034-0.704-0.126-6.225-0.139-11.104c4.706-1.416,17.165-5.314,17.96-7.125 c0.507-1.154,0.49-3.637,0.356-5.769c0.395-0.039,0.829-0.117,1.314-0.25c2.064-0.688,3.096-2.236,4.815-3.439 c1.72-1.032,3.956-1.548,4.987-3.784C251.038,335.039,246.395,337.274,244.159,337.79z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067948288767953580540000002265176668792072873_",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034779991310867215680000001253962528133293444_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067948288767953580540000002265176668792072873_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034779991310867215680000001253962528133293444_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M548.002,347c0,0,10.766-13.168,21.798-16.668c11.032-3.5,29.84-11.948,33.194-16.121 s28.831-0.596,36.213,0c7.382,0.596,27.166-9.784,31.693-10.805c4.527-1.021,26.904-10.407,34.494-9.339 c7.59,1.068,45.818-3.167,45.818-3.167V347H548.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M728.344,299.234c2.507,1.032,3.982,1.18,3.982,1.18c-7.963-9.438-8.995-19.53-8.995-19.53 c3.097,0.672,5.161,0,5.161,0c-3.097-1.687-5.456-4.901-5.456-4.901c2.478,0.829,3.82,1.202,3.82,1.202 c-6.208-7.156-9.866-25.686-9.866-25.686c1.917,0.781,4.793,1.209,4.793,1.209c-5.143-9.678-6.335-16.941-6.335-16.941 c0.965,0.396,2.409,0.074,2.409,0.074c-1.95-2.262-3.263-4.535-3.263-4.535l2.101,0.995c-3.834-2.654-5.385-13.33-5.385-13.33 c1.1,0.811,2.583,0.63,2.583,0.63c-3.687-3.982-6.194-14.009-6.194-14.009s-2.507,10.028-6.194,14.009 c0,0,1.483,0.181,2.583-0.63c0,0-1.551,10.676-5.385,13.33l2.101-0.995c0,0-1.312,2.273-3.263,4.535 c0,0,1.443,0.322,2.409-0.074c0,0-1.192,7.263-6.335,16.941c0,0,2.876-0.428,4.793-1.209c0,0-3.658,18.53-9.866,25.686 c0,0,1.342-0.373,3.82-1.202c0,0-2.359,3.214-5.456,4.901c0,0,2.065,0.672,5.161,0c0,0-1.032,10.092-8.996,19.53 c0,0,1.475-0.147,3.982-1.18c0,0-2.359,5.234-6.194,9.991h26.839h26.839C730.703,304.468,728.344,299.234,728.344,299.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M708.868,298.119c1.994,0.821,3.167,0.938,3.167,0.938c-6.334-7.507-7.155-15.535-7.155-15.535 c2.463,0.535,4.106,0,4.106,0c-2.463-1.342-4.34-3.899-4.34-3.899c1.971,0.66,3.039,0.956,3.039,0.956 c-4.938-5.692-7.848-20.431-7.848-20.431c1.525,0.622,3.812,0.962,3.812,0.962c-4.091-7.698-5.039-13.475-5.039-13.475 c0.768,0.315,1.916,0.059,1.916,0.059c-1.551-1.799-2.595-3.607-2.595-3.607l1.672,0.792 c-3.05-2.111-4.283-10.603-4.283-10.603c0.875,0.645,2.055,0.501,2.055,0.501c-2.932-3.167-4.927-11.144-4.927-11.144 s-1.994,7.977-4.927,11.144c0,0,1.18,0.144,2.055-0.501c0,0-1.234,8.492-4.284,10.603l1.672-0.792 c0,0-1.044,1.808-2.595,3.607c0,0,1.148,0.256,1.916-0.059c0,0-0.948,5.777-5.039,13.475c0,0,2.287-0.34,3.812-0.962 c0,0-2.91,14.739-7.848,20.431c0,0,1.067-0.297,3.039-0.956c0,0-1.877,2.557-4.34,3.899c0,0,1.642,0.535,4.105,0 c0,0-0.821,8.028-7.155,15.535c0,0,1.173-0.117,3.167-0.938c0,0-1.877,4.164-4.927,7.947h21.349h21.349 C710.745,302.283,708.868,298.119,708.868,298.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M751.316,294.15c1.994,0.821,3.167,0.938,3.167,0.938c-6.334-7.507-7.155-15.535-7.155-15.535 c2.463,0.535,4.106,0,4.106,0c-2.463-1.342-4.34-3.899-4.34-3.899c1.971,0.66,3.038,0.956,3.038,0.956 c-4.938-5.692-7.848-20.431-7.848-20.431c1.525,0.622,3.812,0.962,3.812,0.962c-4.091-7.698-5.039-13.475-5.039-13.475 c0.768,0.315,1.916,0.059,1.916,0.059c-1.551-1.799-2.595-3.607-2.595-3.607l1.672,0.792 c-3.05-2.111-4.283-10.603-4.283-10.603c0.875,0.645,2.055,0.501,2.055,0.501c-2.932-3.167-4.927-11.144-4.927-11.144 s-1.994,7.977-4.927,11.144c0,0,1.18,0.144,2.055-0.501c0,0-1.234,8.492-4.283,10.603l1.672-0.792 c0,0-1.044,1.808-2.595,3.607c0,0,1.148,0.256,1.916-0.059c0,0-0.948,5.777-5.039,13.475c0,0,2.287-0.34,3.812-0.962 c0,0-2.91,14.739-7.848,20.431c0,0,1.067-0.297,3.039-0.956c0,0-1.877,2.557-4.34,3.899c0,0,1.642,0.535,4.106,0 c0,0-0.821,8.028-7.155,15.535c0,0,1.173-0.117,3.167-0.938c0,0-1.877,4.164-4.927,7.947h21.349h21.349 C753.193,298.313,751.316,294.15,751.316,294.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M660.035,304.851c2.829,1.165,4.493,1.331,4.493,1.331 c-8.986-10.65-10.151-22.039-10.151-22.039c3.495,0.759,5.824,0,5.824,0c-3.495-1.904-6.157-5.531-6.157-5.531 c2.796,0.935,4.311,1.357,4.311,1.357c-7.005-8.075-11.133-28.984-11.133-28.984c2.163,0.882,5.408,1.365,5.408,1.365 c-5.803-10.92-7.148-19.116-7.148-19.116c1.089,0.447,2.718,0.084,2.718,0.084c-2.201-2.552-3.682-5.117-3.682-5.117 l2.371,1.123c-4.327-2.995-6.077-15.042-6.077-15.042c1.241,0.915,2.915,0.711,2.915,0.711 c-4.16-4.493-6.989-15.809-6.989-15.809s-2.829,11.316-6.989,15.809c0,0,1.674,0.204,2.915-0.711 c0,0-1.75,12.047-6.077,15.042l2.371-1.123c0,0-1.481,2.565-3.682,5.117c0,0,1.629,0.363,2.718-0.084 c0,0-1.345,8.196-7.149,19.116c0,0,3.245-0.483,5.408-1.365c0,0-4.128,20.91-11.133,28.984c0,0,1.514-0.421,4.311-1.357 c0,0-2.662,3.627-6.157,5.531c0,0,2.33,0.759,5.824,0c0,0-1.165,11.389-10.151,22.039c0,0,1.664-0.166,4.493-1.331 c0,0-2.662,5.907-6.989,11.274h30.286h30.286C662.698,310.758,660.035,304.851,660.035,304.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4C48"
    },
    d: "M693.04,302.134c3.275,1.349,5.201,1.541,5.201,1.541 c-10.403-12.329-11.751-25.514-11.751-25.514c4.046,0.879,6.743,0,6.743,0c-4.046-2.204-7.128-6.403-7.128-6.403 c3.237,1.083,4.99,1.57,4.99,1.57c-8.109-9.348-12.889-33.554-12.889-33.554c2.504,1.021,6.261,1.58,6.261,1.58 c-6.719-12.642-8.276-22.131-8.276-22.131c1.261,0.518,3.146,0.097,3.146,0.097c-2.548-2.954-4.262-5.924-4.262-5.924 l2.745,1.3c-5.009-3.468-7.035-17.414-7.035-17.414c1.437,1.059,3.374,0.822,3.374,0.822 c-4.816-5.201-8.091-18.301-8.091-18.301s-3.275,13.1-8.091,18.301c0,0,1.938,0.236,3.375-0.822 c0,0-2.026,13.946-7.035,17.414l2.745-1.3c0,0-1.714,2.969-4.262,5.924c0,0,1.885,0.421,3.146-0.097 c0,0-1.557,9.488-8.276,22.131c0,0,3.757-0.559,6.261-1.58c0,0-4.779,24.206-12.889,33.554c0,0,1.753-0.487,4.99-1.57 c0,0-3.082,4.199-7.128,6.403c0,0,2.697,0.879,6.743,0c0,0-1.349,13.184-11.751,25.514c0,0,1.926-0.193,5.201-1.541 c0,0-3.082,6.838-8.091,13.051h35.061h35.061C696.122,308.972,693.04,302.134,693.04,302.134z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036231962303878310460000018053479865824800384_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 250,
    x2: 750,
    y2: 250
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4F3EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0693,
    style: {
      stopColor: "#DAF5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    style: {
      stopColor: "#EDFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6786,
    style: {
      stopColor: "#F9FDC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    style: {
      stopColor: "#FDFEC2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000036231962303878310460000018053479865824800384_)"
    },
    width: 750,
    height: 500
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "background.cfad32e.svg";
export { ForwardRef as ReactComponent };